export * from './api.service';
export * from './data.service'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/index.ts